export interface JobClass {
  jobClassID: number;
  jobID: string;
  abbreviation: string;
  name: string;
  craft: string;
  linkedClassID: string;
  tradeClassID: string;
  requestedClassName: string;
}
